import { render, staticRenderFns } from "./WidgetKpi.vue?vue&type=template&id=55063cf8&scoped=true&"
import script from "./WidgetKpi.vue?vue&type=script&lang=js&"
export * from "./WidgetKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55063cf8",
  null
  
)

export default component.exports